<!-- @format -->

<div
	id="selectContainer"
	class="select-container hmf-position-relative"
	clickDetectionHandler
	[ngClass]="{ 'hmf-display-none': !dropdownList?.length }"
	(isClickedOutside)="handleClickEvent($event || disabled)">
	<hmf-selector
		id="toggleSelect"
		class="toggle-select"
		[ngClass]="{
			selected: checkedLabelList.length && !disabled,
			'toggle-select-hover-mobile': !checkedLabelList.length && isMobile
		}"
		[ariaLabel]="ariaLabel"
		[circleVariant]="circleVariant"
		[contained]="contained"
		[disabled]="disabled"
		[selector]="selector"
		[selected]="selected"
		(click)="toggleSelect()"
		(keydown.enter)="toggleSelect()"
    	(keydown.space)="toggleSelect()">
		<div
			ngProjectAs="rectangularSelectorBody"
			class="hmf-display-flex hmf-align-items-center hmf-justify-content-between hmf-px-xxs hmf-py-xs">
			<span
				class="content hmf-mr-xs"
				[ngClass]="{
					'hmf-body-bold-m content-selected': checkedLabelList.length,
					'hmf-body-m': !checkedLabelList.length
				}">
				{{ label }}
			</span>

			<homefield-icon
				class="review-chip-svg"
				width="16px"
				height="16px"
				[name]="showDropdown ? 'chevron-up' : 'chevron-down'">
			</homefield-icon>
		</div>
	</hmf-selector>

	<div
		id="optionsContainer"
		class="display-dropdown-options hmf-position-absolute hmf-elevated-shadow"
		[ngClass]="{
			'display-dropdown-options--bottom hmf-mb-xl': isMobile && isBottom,
			'hmf-display-none': !showDropdown,
			'hmf-display-flex hmf-flex-column hmf-align-items-start hmf-justify-content-between':
				showDropdown
		}"
		[insideViewport]="isMobile && showDropdown"
		(isElementVisible)="handleElementPosition($event)">
		<!-- Multiple/Single choice template -->
		@for (dropdownValue of dropdownList; track trackByKey($index, dropdownValue)) {
			<button
				class="dropdown-option hmf-display-flex hmf-align-items-center hmf-px-s hmf-py-xs hmf-m-0"
				[ngClass]="{ selected: dropdownValue.selected }"
				(keydown)="lostFocus($event, index)"
				(click)="getSelectedValue(!dropdownValue.selected, dropdownValue)">
				<input
					class="multiple-choice hmf-mr-xxs"
					type="checkbox"
					tabindex="-1"
					[ngClass]="{
						'hmf-display-none': !isMultipleChoice,
						'hmf-display-flex hmf-align-items-center hmf-justify-content-between':
							isMultipleChoice,
						active: dropdownValue.selected
					}"
					[checked]="dropdownValue.selected" />
				<span
					class="hmf-body-m hmf-body-l-l"
					[ngClass]="{ 'hmf-body-bold-m hmf-body-bold-l-l': dropdownValue.selected }">
					{{ dropdownValue.label }}
				</span>
			</button>
		}
	</div>
</div>
